import { FC } from 'react'
import * as cn from 'classnames'
import * as styles from 'styles/molecules/tables/Table2.css'
import { AccountType, DetailedAccount } from 'interfaces/accounts'
import { EmptyCardBlock } from 'components/features/pfm/Blocks/Blocks'
import { CategoryId } from 'interfaces/meta'
import NoAccountsCopy from 'components/molecules/NoAccountsCopy'
import AccountsDetailsRow from 'components/molecules/tables/AccountsDetailsRow'
import Table2 from 'components/molecules/tables/Table2'
import AccountsDetailsHeader from 'components/molecules/tables/AccountsDetailsHeader'
import AccountsDetailsRowMobile from 'components/molecules/tables/AccountsDetailsRowMobile'
import CommonHeaderMobile from 'components/molecules/tables/CommonHeaderMobile'
import { BaseSorting } from 'interfaces/table'

export type AccountsDetailsStateProps = {
  isMobile: boolean
  rows: DetailedAccount[]
}

export type AccountsDetailsOwnProps = {
  type: AccountType
  categoryId?: CategoryId
}

type AccountsDetailsProps = AccountsDetailsStateProps & AccountsDetailsOwnProps

const getAccountType = ({ category }: DetailedAccount) => category.value
const getRowKey = (row: DetailedAccount) => `${ row.is_manual ? 'manual' : 'connected' }-${ row.id }`

const DEFAULT_SORTING: BaseSorting = {
  columnName: 'account_type',
  direction: 'asc',
}

const AccountsDetailsModule: FC<AccountsDetailsProps> = (props) => {
  const {
    categoryId,
    rows,
    type,
    isMobile,
  } = props

  const RowComponent = isMobile ? AccountsDetailsRowMobile : AccountsDetailsRow
  const HeaderComponent = isMobile ? CommonHeaderMobile : AccountsDetailsHeader

  const className = cn({
    [styles.isMobile]: isMobile,
    [styles.debtsAccountDetails]: type === 'debts',
    [styles.assetsAccountDetails]: type === 'assets',
  })

  const table = (
    <div className={ className }>
      <Table2
        rows={ rows }
        getRowKey={ getRowKey }
        sorting={ DEFAULT_SORTING }
      >
        <Table2.HeadRowMarker>
          <HeaderComponent type={ type } />
        </Table2.HeadRowMarker>
        <Table2.Rows>
          <Table2.RowSpan name='account_type' force={ isMobile }>
            { getAccountType }
          </Table2.RowSpan>
          <Table2.RowTemplate>
            {
              (row: DetailedAccount) => (
                <RowComponent
                  key={ getRowKey(row) }
                  type={ type }
                  row={ row }
                />
              )
            }
          </Table2.RowTemplate>
        </Table2.Rows>
      </Table2>
    </div>
  )

  return rows.length
    ? table
    : (
      <EmptyCardBlock>
        <NoAccountsCopy type={ type } categoryId={ categoryId } standalone />
      </EmptyCardBlock>
    )
}

// TODO accounts; unify `NoAccountsCopy` with a copy when no transactions
export default AccountsDetailsModule
